<template>
  <div class="notify-page">
    <h2 class="page-title">发家长通知</h2>
    <el-card>
      <el-alert
        title="站内通知会进入家长端「通知」列表，用于训练计划、放假、上课提醒等（非催费）。"
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom:16px"
      />

      <el-form label-width="110px" style="max-width:640px">
        <el-form-item label="发送范围">
          <el-radio-group v-model="scope">
            <el-radio label="one">指定学员</el-radio>
            <el-radio label="low_hours">课时不足家长</el-radio>
            <el-radio label="all">全部家长</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="scope === 'one'" label="选择学员">
          <el-select
            v-model="studentId"
            filterable
            remote
            clearable
            placeholder="输入姓名/电话搜索"
            :remote-method="searchStudents"
            :loading="studentLoading"
            style="width:100%"
          >
            <el-option
              v-for="s in studentOptions"
              :key="s.id"
              :label="`${s.name}（剩余${s.remainingHours}）`"
              :value="String(s.id)"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="快捷模板">
          <el-button size="mini" @click="applyTpl('plan')">本周训练</el-button>
          <el-button size="mini" @click="applyTpl('holiday')">放假通知</el-button>
          <el-button size="mini" @click="applyTpl('class')">上课提醒</el-button>
        </el-form-item>

        <el-form-item label="标题">
          <el-input v-model="title" maxlength="40" show-word-limit placeholder="俱乐部通知" />
        </el-form-item>

        <el-form-item label="内容" required>
          <el-input
            v-model="content"
            type="textarea"
            :rows="5"
            maxlength="500"
            show-word-limit
            placeholder="可用 {name} 表示学员姓名（系统会按学员替换）"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="loading" @click="submit">发送</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getStudents, sendAdminNotification } from '../api'

const TPL = {
  plan: {
    title: '本周训练计划',
    content: '家长您好，{name} 本周训练安排请留意俱乐部通知，请按时到场。'
  },
  holiday: {
    title: '放假通知',
    content: '家长您好，近期课程安排有调整，请关注俱乐部通知，避免空跑。'
  },
  class: {
    title: '上课提醒',
    content: '家长您好，请提醒 {name} 按时上课，带好球拍与球鞋。'
  }
}

export default {
  name: 'Notify',
  data() {
    return {
      scope: 'all',
      studentId: '',
      studentOptions: [],
      studentLoading: false,
      title: '俱乐部通知',
      content: '',
      loading: false
    }
  },
  created() {
    const q = this.$route.query || {}
    if (q.scope === 'one' || q.scope === 'low_hours' || q.scope === 'all') {
      this.scope = q.scope
    }
    if (q.id) {
      this.scope = 'one'
      this.studentId = String(q.id)
      this.studentOptions = [{
        id: Number(q.id),
        name: q.name ? decodeURIComponent(q.name) : ('学员#' + q.id),
        remainingHours: Number(q.remaining) || 0
      }]
    }
  },
  methods: {
    applyTpl(key) {
      const tpl = TPL[key]
      if (!tpl) return
      this.title = tpl.title
      this.content = tpl.content
    },
    async searchStudents(keyword) {
      this.studentLoading = true
      try {
        const res = await getStudents({
          page: 1,
          size: 20,
          keyword: keyword || '',
          courseType: 0
        })
        this.studentOptions = (res.data && res.data.records) || []
      } finally {
        this.studentLoading = false
      }
    },
    async submit() {
      if (this.scope === 'one' && !this.studentId) {
        return this.$message.warning('请先选择学员')
      }
      const content = String(this.content || '').trim()
      if (!content) {
        return this.$message.warning('请填写通知内容')
      }
      const scopeLabel = this.scope === 'all'
        ? '全部学员家长'
        : (this.scope === 'low_hours' ? '课时不足学员家长' : '该学员家长')
      try {
        await this.$confirm('将站内通知：' + scopeLabel, '确认发送', { type: 'warning' })
      } catch (e) {
        return
      }
      this.loading = true
      try {
        const res = await sendAdminNotification({
          scope: this.scope,
          studentId: this.scope === 'one' ? this.studentId : undefined,
          title: String(this.title || '').trim() || undefined,
          content
        })
        const sent = (res.data && res.data.sent) || 0
        this.$message.success('已发送给 ' + sent + ' 位家长')
        if (this.scope === 'one') {
          this.$router.back()
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.page-title { margin: 0 0 16px; font-size: 20px; color: #1E293B; }
</style>
